export async function uploadFileToTemp(
  file: File,
  { tempKey, tempPutUrl }: { tempKey: string; tempPutUrl: string },
): Promise<{ name: string; contentType: string; size: number; tempKey: string }> {
  const contentType = file.type || 'application/octet-stream';
  const res = await fetch(tempPutUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': contentType },
  });
  if (!res.ok) {
    throw new Error(`Upload failed: ${res.status} ${res.statusText}`);
  }
  return {
    name: file.name,
    contentType,
    size: file.size,
    tempKey,
  };
}
